<template>
  <div class="appcontainer">
    <div class="logo-box">
      <img src="@/assets/logo.png" class="logo-img" />

      <div class="cs" @click="gotoCs">
        <div class="cs-icon">
          <img class="cs-img pulse-effect" src="@/assets/icon-cs.png" />
          <!-- 客服回复了还没看：红点 -->
          <span v-if="csUnread > 0" class="cs-dot"></span>
        </div>
        <CanvasText
          text="在线客服"
          :font-size="0.3"
          unit="rem"
          color="#fff"
          align="center"
        />
      </div>
    </div>

    <div class="mobile-container">
      <div class="grid-box1">
        <div class="gird-item1">
          <div
            class="tech-item item-purchase"
            @click="gotoArticle('video', 'buy_course')"
          >
            <img src="@/assets/play-icon.png" />
            <CanvasText
              text="PG币"
              :font-size="0.48"
              unit="rem"
              color="#fff"
              :line-height="1.5"
            />
            <div class="pgb-divider"></div>
            <CanvasText
              text="交易买币"
              :font-size="0.53333"
              unit="rem"
              color="#edd185"
              :line-height="1.5"
            />
          </div>
        </div>
        <div class="gird-item1">
          <div
            class="tech-item item-sell"
            @click="gotoArticle('video', 'sell_course')"
          >
            <img src="@/assets/play-icon.png" />
            <CanvasText
              text="PG币"
              :font-size="0.48"
              unit="rem"
              color="#fff"
              :line-height="1.5"
            />
            <div class="pgb-divider"></div>
            <CanvasText
              text="挂单卖币"
              :font-size="0.53333"
              unit="rem"
              color="#edd185"
              :line-height="1.5"
            />
          </div>
        </div>
      </div>

      <button class="web-btn" @click="jumpWeb">
        <CanvasText
          text="前往网页版"
          :font-size="0.42667"
          unit="rem"
          font-weight="700"
          color="#000"
          align="center"
        />
      </button>

      <button class="download-btn" @click="gotoDownload">
        <CanvasText
          text="前往App下载"
          :font-size="0.42667"
          unit="rem"
          font-weight="700"
          color="#000"
          align="center"
        />
      </button>
    </div>

    <div class="pc-btn">
      <!-- <div class="btn-item pulse-effect">
        <img src="@/assets/icon-cs.png" @click="gotoCs" />
      </div> -->
      <div class="btn-item">
        <img src="@/assets/icon-tg.png" @click.stop="tgShow = !tgShow" />
        <div v-if="tgShow" class="tg-pop">
          <CanvasText text="合作Telegram" :font-size="0.37333" unit="rem" color="#fff" />
          <CanvasText
            :text="'商务：' + website.telegram"
            :font-size="0.37333"
            unit="rem"
            color="#fff"
          />
        </div>
      </div>
    </div>

    <div v-if="tgShow" class="mobile-pop">
      <img src="@/assets/icon-tg2.png" class="tg-icon" />
      <CanvasText
        text="合作Telegram"
        :font-size="0.53333"
        unit="rem"
        color="#fff"
        :line-height="1.5"
        class="tg-title"
      />
      <div class="tg-link">
        <CanvasText
          :text="'商务：' + website.telegram"
          :font-size="0.42667"
          unit="rem"
          color="#fff"
          :line-height="1.5"
          class="link-left"
        />
        <img
          src="@/assets/copy-white-icon.png"
          class="tg-copy"
          @click="copyLink"
        />
      </div>
      <img
        src="@/assets/close-icon.png"
        class="tg-close"
        @click.stop="tgShow = false"
      />
    </div>
    <CsPanel ref="cs" @unread="csUnread = $event" />
  </div>
</template>
<script>
import QRCode from "qrcode"; //引入生成二维码插件
import ClipboardJS from "clipboard";
import { resolveWildcardUrl } from "@/utils/wildcardUrl";
import CanvasText from "@/components/CanvasText.vue";
import CsPanel from "@/components/CsPanel.vue";
import { csEnabled } from "@/cs/config";

export default {
  name: "Index",
  components: { CanvasText, CsPanel },
  data() {
    return {
      website: {
        onlineCustom: process.env.VUE_APP_ONLINE_SUPPORT_URL,
        telegram: process.env.VUE_APP_TELEGRAM,
        pgbH5: process.env.VUE_APP_WEB_URL,
      },
      tgShow: false,
      csUnread: 0,
      tabList: [],
      introObj: {},
      introActive: 0,
      faqList: [],
      copyObj: "",
    };
  },
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.generateCode(`${window.location.href}download`);
    // });
  },
  methods: {
    // calcFontSize() {
    //   let designWidth;
    //   // 获取当前设备宽度
    //   const deviceWidth = document.documentElement.clientWidth;
    //   if (deviceWidth <= 900) {
    //     designWidth = 375;
    //   } else {
    //     designWidth = 1920;
    //   }
    //   // 设置 <html> 的 font-size，确保页面内容按比例缩放
    //   document.documentElement.style.fontSize = `${
    //     (designWidth / 10) * (deviceWidth / designWidth)
    //   }px`;
    // },
    gotoDownload() {
      this.$router.push({ name: "Download" });
    },
    jumpWeb() {
      const pgbH5Url = resolveWildcardUrl(this.website.pgbH5);
      if (pgbH5Url) {
        window.open(pgbH5Url, "_blank");
      }
    },
    // getWebsitePcData() {
    //   getWebsitePc().then((res) => {
    //     this.website = res;
    //     this.$nextTick(() => {
    //       this.generateCode(res.downUrl);
    //     });
    //   });
    // },
    // generateCode(downUrl) {
    //   // console.log(document.getElementById('qrcode').getBoundingClientRect().width)
    //   const size = parseInt(
    //     document.getElementById("qrcode").getBoundingClientRect().width
    //   );
    //   // if(this.qrcode) {
    //   //     qrcode.clear(); // clear the code.
    //   // }
    //   const id = document.getElementById("qrCanvas");
    //   var qrcode = QRCode.toCanvas(
    //     id,
    //     downUrl,
    //     {
    //       errorCorrectionLevel: "H", //容错级别
    //       type: "image/png", //生成的二维码类型
    //       quality: 0.3, //二维码质量
    //       margin: 1, //二维码留白边距
    //       width: size,
    //     },
    //     (error) => {
    //       console.log("error", error);
    //     }
    //   );
    // },
    getIntroListData() {
      getIntroList().then((res) => {
        this.tabList = res;
        this.handleIntroObj();
      });
    },
    introTabChange(index) {
      if (this.introActive === index) return;
      this.introActive = index;
      this.handleIntroObj();
    },
    handleIntroObj() {
      if (this.tabList?.length > 0) {
        this.introObj = this.tabList[this.introActive];
      }
    },
    getFaqListData() {
      getFaqList().then((res) => {
        this.faqList = res.map((item, index) => {
          item.open = index === 0;
          return item;
        });
      });
    },
    gotoArticle(type, id) {
      this.$router.push({ name: "Article", params: { type: type, id: id } });
    },
    copyLink() {
      if (!this.copyObj) {
        this.copyObj = new ClipboardJS(".tg-copy", {
          text: (trigger) => {
            return this.website.telegram;
          },
        }).on("success", (e) => {
          this.$toast("复制成功", 1500); // 显示1.5秒
        });
      }
    },
    gotoCs() {
      // 原生接入的在线客服：当前页弹出聊天窗，不跳转
      if (csEnabled()) {
        this.$refs.cs.open();
        return;
      }
      // 没配原生客服时沿用外部客服链接：每次点击都重新解析，配置里的 * 会换成新的 32 位随机二级域名
      const csUrl = resolveWildcardUrl(this.website.onlineCustom);
      if (csUrl) {
        window.open(csUrl, "_blank");
      }
    },
  },
  filters: {
    activeTextFilter(index) {
      if (index == 0) {
        return "PGB由来";
      } else if (index == 1) {
        return "PGB理念";
      } else if (index == 2) {
        return "PGB技术";
      } else if (index == 3) {
        return "PGB愿景";
      }
      return index;
    },
  },
};
</script>
<style lang="scss" scoped>
.pulse-effect {
  border-radius: 50%;
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(248, 191, 84, 0.8);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(248, 191, 84, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(248, 191, 84, 0);
  }
}
.appcontainer {
  height: auto;
  min-height: 100vh;
  background-color: #000;
  background-size: contain;
  background-repeat: no-repeat;
  display: block;

  .logo-box {
    position: relative;
    padding: 0.6rem 0.4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .logo-img {
      height: 0.7rem;
      flex-shrink: 0;
    }
    .cs {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      .cs-icon {
        position: relative;
        margin-bottom: 0.1rem;
      }
      .cs-img {
        display: block;
        width: 0.75rem;
      }
      .cs-dot {
        position: absolute;
        top: 0;
        right: 0;
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        background: #ff3b30;
        border: 0.04rem solid #000;
      }
      span {
        color: #fff;

        font-size: 0.3rem;
      }
    }

    .logo-name {
      color: #fff;
      font-family: PangMenZhengDao;
      font-size: 0.48rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding-left: 0.2rem;
    }
  }

  .pc-container {
    display: none;
  }

  .mobile-container {
    display: block;
    padding: 0 0.4rem 1.7rem 0.4rem;

    .mobile-slogan {
      margin-top: 0.2rem;
      display: flex;
      height: 1.06667rem;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.64rem;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      /* 0.96rem */
    }

    .download-btn {
      border-width: 0;
      display: flex;
      width: 100%;
      height: 1.2rem;
      justify-content: center;
      align-items: center;
      gap: 0.26667rem;
      flex-shrink: 0;
      border-radius: 4.06rem;
      //  background: linear-gradient(135deg, #f8bf54 0%, #edd185 100%);
      background: linear-gradient(90deg, #ffcc33, #f8bf54, #ff9900, #ffcc33);
      background-size: 200% 100%;
      animation: gradiientMove 2.3s linear infinite;
      color: #000;
      font-family: "PingFang SC";
      font-size: 0.42667rem;
      font-style: normal;
      font-weight: 700;
      transition: opacity 0.4s;
    }

    .web-btn {
      border-width: 0;
      display: flex;
      width: 100%;
      height: 1.2rem;
      justify-content: center;
      align-items: center;
      gap: 0.26667rem;
      flex-shrink: 0;
      border-radius: 4.06rem;
      //  background: linear-gradient(135deg, #f8bf54 0%, #edd185 100%);
      background: linear-gradient(90deg, #ffcc33, #f8bf54, #ff9900, #ffcc33);
      background-size: 200% 100%;
      animation: gradiientMove 2.3s linear infinite;
      color: #000;
      font-family: "PingFang SC";
      font-size: 0.42667rem;
      font-style: normal;
      font-weight: 700;
      transition: opacity 0.4s;
      margin-bottom: 0.5rem;
    }

    @keyframes gradiientMove {
      0% {
        background-position: 0% 0%;
      }
      100% {
        background-position: 200% 0%;
      }
    }

    .tech-title {
      display: flex;
      height: 1.06667rem;
      align-items: center;
      justify-content: center;
      margin: 0 0 0.8rem;
      color: #fff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 0.64rem;
      font-style: normal;
      font-weight: 400;
    }

    .tech-item {
      width: 100%;
      height: 4.53333rem;
      margin-bottom: 0.53rem;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 0.26667rem;
      background-color: #141414;
      position: relative;
      padding: 0.83rem 0 0 0.93rem;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1.06667rem;
        height: 1.06667rem;
      }

      .pgb {
        color: #fff;
        font-family: "PingFang SC";
        font-size: 0.48rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 0.72rem */
      }

      .pgb-divider {
        margin: 0.09rem 0 0.17rem;
        width: 0.65333rem;
        height: 0.05333rem;
        background-color: #edd185;
      }

      .pgb-desc {
        color: #edd185;
        font-family: "PingFang SC";
        font-size: 0.53333rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 0.8rem */
      }
    }

    .item-intro {
      background-image: url(../assets/tech1.png);
    }

    .item-purchase {
      background-image: url(../assets/tech2.png);
    }

    .item-sell {
      background-image: url(../assets/tech3.png);
    }

    .pgb-intro-title {
      margin-top: 0.8rem;
      margin-bottom: 1.07rem;
      display: flex;
      width: 100%;
      height: 1.06667rem;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.64rem;
      font-style: normal;
      font-weight: 400;
    }

    .pgb-intro-tab {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

      .intro-tab-item {
        display: flex;
        width: 2rem;
        height: 0.8rem;
        justify-content: center;
        align-items: center;
        border-radius: 0.13333rem;
        background: #2a2a2a;
        color: #fff;
        font-family: "PingFang SC";
        font-size: 0.37333rem;
        font-style: normal;
        font-weight: 400;
      }

      .tab-active {
        background: linear-gradient(135deg, #f8bf54 0%, #edd185 100%);
        color: #000;
      }
    }

    .pgb-intro-img {
      margin-top: 0.93rem;
      width: 100%;
      height: 5.38667rem;
      object-fit: cover;
    }

    .pgb-intro-sub-title {
      margin-top: 0.53rem;
      display: flex;
      width: 100%;
      height: 1.06667rem;
      align-items: center;
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.58667rem;
      font-style: normal;
      font-weight: 400;
    }

    .pgb-intro-text {
      margin-top: 0.4rem;
      color: #b7b7b7;
      font-family: "PingFang SC";
      font-size: 0.37333rem;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      /* 0.56rem */
    }

    .question-divider {
      margin-top: 0.4rem;
      width: 100%;
      height: 0.02rem;
      background-color: #515051;
    }

    .question-title {
      margin-top: 0.83rem;
      margin-bottom: 0.4rem;
      display: flex;
      width: 100%;
      height: 1.06667rem;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 0.64rem;
      font-style: normal;
      font-weight: 400;
    }

    .question-card {
      margin-top: 0.27rem;
      padding: 0.48rem 0.4rem 0.45rem;
      border-radius: 0.26667rem;
      background: #141414;

      .card-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 0.53333rem;
        align-items: center;
        position: relative;

        &::before {
          display: block;
          content: "";
          position: absolute;
          left: -0.4rem;
          top: 50%;
          transform: translateY(-50%);
          width: 0.10667rem;
          height: 0.4rem;
          border-radius: 0.53333rem;
          background: linear-gradient(135deg, #f8bf54 0%, #edd185 100%);
        }

        .title-text {
          color: #fff;
          font-family: "PingFang SC";
          font-size: 0.42667rem;
          font-style: normal;
          font-weight: 400;
        }

        .arrow {
          width: 0.32rem;
          height: 0.32rem;
        }
      }

      .fade-enter-active {
        transition: opacity 0.2s ease;
      }
      .fade-leave-active {
        transition: opacity 0.1s ease;
      }
      .fade-enter-from,
      .fade-leave-to {
        opacity: 0;
      }

      .card-body {
        .card-line {
          margin-top: 0.27rem;
          display: flex;
          width: 100%;
          height: 0.53333rem;
          align-items: center;
          color: #b7b7b7;
          font-family: "PingFang SC";
          font-size: 0.37333rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          /* 0.52267rem */
        }
      }
    }
  }

  .pc-btn {
    position: fixed;
    right: 0.4rem;
    bottom: 1.2rem;
    display: flex;
    flex-direction: column;
    // PC 端居中布局时，按钮贴在 10rem 宽的内容列右侧，而不是屏幕右侧
    @media (min-width: 500px) {
      right: calc(50% - 5rem + 0.4rem);
    }

    .btn-item {
      display: flex;

      &:nth-of-type(1) {
        margin-bottom: 0.4rem;
        position: relative;
      }

      img {
        width: 1.06667rem;
        height: 1.06667rem;
        cursor: pointer;
        user-select: none;
      }

      .tg-pop {
        display: none;
      }
    }
  }

  .mobile-pop {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 7.86667rem;
    height: 5.2rem;
    border-radius: 0.4rem;
    background: #1296db;
    z-index: 100;
    padding-top: 0.8rem;

    .tg-icon {
      width: 1.06667rem;
      height: 1.06667rem;
    }

    .tg-title {
      color: #fff;
      font-family: "PingFang SC";
      font-size: 0.53333rem;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      /* 0.8rem */
      margin: 0.32rem 0 0.4rem;
    }

    .tg-link {
      display: flex;
      align-items: center;

      .link-left {
        color: #fff;
        font-family: "PingFang SC";
        font-size: 0.42667rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        /* 0.64rem */
      }

      .tg-copy {
        width: 0.42667rem;
        height: 0.42667rem;
        margin-left: 0.29rem;
      }
    }

    .tg-close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -2rem;
      width: 0.93333rem;
      height: 0.93333rem;
    }
  }
}
</style>
